import React, { useEffect, useState, useRef } from "react";
import useHttp from '../../../../hook/use-http';
import NoData from '../NoData';
import ChartLoader from '../ChartLoader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillCalendarCheckFill } from "react-icons/bs";
import moment from 'moment';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { BsZoomIn } from "react-icons/bs";
import * as $ from 'jquery';

import Chart from 'react-apexcharts'
import WaterMark from "../../DashboardMain/WaterMark";

export default function ROC_vehicle_scatter({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const [selectedD, setselectedD] = useState(new Date());
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterenddata, setFilterendData] = useState({});
  const dateselection = useRef();
  const [width, setWidth] = useState(window.innerWidth);
  const [barColor, setBarColor] = useState("#348393")

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width < 768
  const issmMobile = width < 385;

  const appyData = (data) => {
    const res_result = data;
    const date_display = data.date_display;

    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        name: "ROC",
        data: []
      }]
      let y_data_set = [];
      temp_result.sort((a, b) => b.fields.gun_start[0].localeCompare(a.fields.gun_start[0]));
      temp_result.map((x, i) => {
        res_result_final[0].data.push([parseInt(i + 1), x.fields.ROC[0].toFixed(2)]);
      })
      setChartData((prestate) => res_result_final);
      setselectedD(moment(new Date(date_display)).toDate());
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      setselectedD(moment(new Date(date_display)).toDate());
      window.dispatchEvent(new Event('resize'));
    }
  }
  let xvalue, yvalue;
  if (isMobile === true) {
    xvalue = 85; yvalue = 80
  } else {
    xvalue = 85; yvalue = 78
  }
  const chageDateSelection = () => {
    dateselection.current.setFocus();
  }
  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const options = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',
    },
    colors: [barColor],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: "ROC %/hr",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 7,
      title: {
        text: "Cycle Number",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: yvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };

  const options1 = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',
    },
    colors: [barColor],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: "ROC %/hr",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 7,
      title: {
        text: "Cycle Number",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: xvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };

  useEffect(() => {
    (type === 'Slow') ? setBarColor("#348393") : setBarColor("#FFA650")
    fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
  }, [gloablfilter, type])

  const chnageSelection = (date) => {
    setselectedD(date);
    fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
  }
  const rezoom = () => {
    window.$('#torquespeedsecond').modal('show');
    window.dispatchEvent(new Event('resize'));
  }

  return (
    <>
      <div className="modal fade" id="torquespeedsecond" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Rate of charging {type} chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <WaterMark />
              {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart options={options1} series={chartdata} type="scatter" width="100%" height="360px" />)}
            </div>
          </div>
        </div>
      </div>

      <strong className="d-flex justify-content-end" style={{ cursor: "pointer", marginRight: "5px" }} onClick={rezoom} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart type="scatter" width="100%" height="170px" series={chartdata} options={options} />)}
    </>
  );
}
